import React from 'react';
import PropTypes from 'prop-types';

import CommentField from './CommentField';
import utils from './utils';

import { toast } from '../toast';

class CommentEdit extends React.Component {
    componentDidMount () {
        this.editField.setContent(this.props.comment.content);
        this.editField.setFocus();
    };

    cancelEdit = () => {
        this.editField.clear();
        this.props.expandedComment.exitEditing();
    }

    renderCommentFieldActions = () =>
        (<span className='comment-actions'>
            <a
                className={`comment-action-btn ${this.editField.hasError() ? 'disabled' : ''}`}
                onClick={ !this.editField.hasError() ? this.updateComment : null }
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='Finish_Edit_Comment'
            >{ gettext('Finish') }</a>
            <a
                className='comment-action-btn'
                onClick={this.cancelEdit}
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='Cancel_Edit_Comment'
            >{ gettext('Cancel') }</a>
        </span>);

    updateComment = () => {
        if (this.editField.isEmpty || this.editField.isProcessing() || this.editField.hasError()) {
            return Promise.reject();
        }

        this.editField.setProcessing(true);

        const updatedComment = {
            id: this.props.comment.id,
            content: this.editField.getContent()
        };

        const mentions = utils.getMentions(updatedComment.content);
        return this.props.commentsStore.checkMentionPermissionsAndAlert(mentions)
            .then(() => {
                return this.props.commentsStore.api
                    .updateComment(this.props.commentsStore.resource, updatedComment, mentions)
                    .then(res => {
                        this.props.commentsStore.replaceComment(res);
                    })
                    .catch(err => {
                        this.editField.setProcessing(false);
                        toast('ERROR_OCCURED');
                    });
            });
    };

    render () {
        return (<CommentField
            ref={editField => { this.editField = editField; }}
            placeholder={this.props.comment.content}
            onEnter={this.updateComment}
            onEscape={this.props.onEscape}
            childrenFunc={this.renderCommentFieldActions}
            commentsStore={this.props.commentsStore}
        />);
    }
};

export default CommentEdit;

CommentEdit.propTypes = {
    onEscape: PropTypes.func,
    comment: PropTypes.object,
    commentsStore: PropTypes.object.isRequired,
    expandedComment: PropTypes.object.isRequired
};
